module.exports = __webpack_public_path__ + "static/img/40003 (1).9f8739e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40003 (1).webp
// module id = ot8M
// module chunks = 14